// @ts-ignore
import $ from 'jquery';
// import WOW  from 'wowjs'
// new WOW.WOW().init();
import magnificPopup from 'magnific-popup';
!(function ($)  {
	"use strict";

	var windowOn = $(window);


	////////////////////////////////////////////////////
	// 04. Body overlay Js
	$(".body-overlay").on("click", function () {
		$(".sidebar__area").removeClass("sidebar-opened");
		$(".body-overlay").removeClass("opened");
	});

	////////////////////////////////////////////////////
	// 05. Search Js
	$(".search-toggle").on("click", function () {
		$(".search__area").addClass("opened");
	});
	$(".search-close-btn").on("click", function () {
		$(".search__area").removeClass("opened");
	});

	////////////////////////////////////////////////////
	// 06. Sticky Header Js
	windowOn.on('scroll', function () {
		var scroll = $(window).scrollTop();
		if (scroll < 100) {
			$("#header-sticky").removeClass("header__sticky");
		} else {
			$("#header-sticky").addClass("header__sticky");
		}
	});

	////////////////////////////////////////////////////
	// 07. Data CSS Js
	$("[data-background").each(function () {
		$(this).css("background-image", "url( " + $(this).attr("data-background") + "  )");
	});

	$("[data-width]").each(function () {
		$(this).css("width", $(this).attr("data-width"));
	});

	$("[data-bg-color]").each(function () {
		$(this).css("background-color", $(this).attr("data-bg-color"));
	});



	////////////////////////////////////////////////////
	// 23. InHover Active Js
	$('.hover__active').on('mouseenter', function () {
		$(this).addClass('active').parent().siblings().find('.hover__active').removeClass('active');
	});


	// Jquery Appear raidal
	if (typeof ($.fn.knob) != 'undefined') {
		$('.knob').each(function () {
			var $this = $(this),
				knobVal = $this.attr('data-rel');

			$this.knob({
				'draw': function () {
					$(this.i).val(this.cv + '%')
				}
			});

			$this.appear(function () {
				$({
					value: 0
				}).animate({
					value: knobVal
				}, {
					duration: 2000,
					easing: 'swing',
					step: function () {
						$this.val(Math.ceil(this.value)).trigger('change');
					}
				});
			}, {
				accX: 0,
				accY: -150
			});
		});
	}



	// colse button
	if (jQuery(".close-button").length > 0) {
		const closeBtn = document.querySelector('.close-button');
		closeBtn.addEventListener('click', function () {
			const append = document.querySelector('.appoinment-cta-2');
			append.classList.add('hide')
		})
	}

})($, window, jQuery);

!function(s) {
    "use strict";
	s(".switch").on("click",
		function() {
			s("body").hasClass("light") ? (s("body").removeClass("light"), s(".switch").removeClass("switched")) : (s("body").addClass("light"), s(".switch").addClass("switched"))
	}),
    s(document).ready(function() {
		s('.image-link').magnificPopup({removalDelay: 300,mainClass: 'mfp-fade'});
        var e = document.querySelector(".progress-wrap path"),
        t = e.getTotalLength();
        e.style.transition = e.style.WebkitTransition = "none",
        e.style.strokeDasharray = t + " " + t,
        e.style.strokeDashoffset = t,
        e.getBoundingClientRect(),
        e.style.transition = e.style.WebkitTransition = "stroke-dashoffset 5ms linear";
        var o = function() {
            var o = s(window).scrollTop(),
            r = s(document).height() - s(window).height(),
            i = t - o * t / r;
            e.style.strokeDashoffset = i
        };
        o(),
        s(window).scroll(o);
        jQuery(window).on("scroll",
        function() {
            jQuery(this).scrollTop() > 50 ? jQuery(".progress-wrap").addClass("active-progress") : jQuery(".progress-wrap").removeClass("active-progress")
        }),
        jQuery(".progress-wrap").on("click",
        function(s) {
            return s.preventDefault(),
            jQuery("html, body").animate({
                scrollTop: 0
            },
            550),
            !1
        }),
		jQuery(".header-search-button").on("click",
		function() {
			if (jQuery(".header-search-wrapper").hasClass("novis_search")){
				jQuery(".header-search-wrapper").fadeIn(1).addClass("vis-search").removeClass("novis_search");
				jQuery(".header-search-button").addClass("hsbclose");
			}
			else {
				jQuery(".header-search-wrapper").fadeOut(1).removeClass("vis-search").addClass("novis_search");
				jQuery(".header-search-button").removeClass("hsbclose");
			}
		});
		jQuery(".mor-opt-btn_act").on("click",
		function() {
			if (jQuery(".more-search-opt-wrap").hasClass("more-hidden_wrap")) {
				jQuery(".more-search-opt-wrap").addClass("vis-more-search").removeClass("more-hidden_wrap");
			}
			else {
				jQuery(".more-search-opt-wrap").removeClass("vis-more-search").addClass("more-hidden_wrap");
			}
		});
		jQuery(".close_msotw").on("click",
		function() {
			jQuery(".more-search-opt-wrap").removeClass("vis-more-search").addClass("more-hidden_wrap");
		});
		jQuery(document).on("mouseenter", ".suspension .a", function(){
			var _this = jQuery(this);
			var s = jQuery(".suspension");
			var isService = _this.hasClass("a-service");
			var isServicePhone = _this.hasClass("a-service-phone");
			var isQrcode = _this.hasClass("a-qrcode");
			if(isService){ s.find(".d-service").show().siblings(".d").hide();}
			if(isServicePhone){ s.find(".d-service-phone").show().siblings(".d").hide();}
			if(isQrcode){ s.find(".d-qrcode").show().siblings(".d").hide();}
		});
		jQuery(document).on("mouseleave", ".suspension", function(){
			jQuery(".suspension").find(".d").hide();
		});
		jQuery(document).on("mouseenter", function(){
			jQuery(".suspension").find(".d").hide(); 
		});
    })
} ($);